
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import NotificationComponent from '@/views/Notification/components/notification.vue'

import NotificationModel from '@/views/Notification/models/notification'
import ExportModel from '@/views/Project/Observation/model/export'
import NotificationGroupModel from '@/views/Notification/models/notificationGroup'

const NotificationGroupComponent = Vue.extend({
    mixins: [AppMixin],
    components: { NotificationComponent },
    props: { notificationGroup: NotificationGroupModel, read: Boolean },
    data: () => ({
        loadingMarkAsRead: false,
        loadingMoreNotifications: false,
        exportFile: null as ExportModel | null,
        limit: 50,
    }),
    computed: {
        link() {
            let link: null | Record<string, any> = null
            switch (this.notificationGroup.resource.moduleId) {
                case 'observation':
                    if (this.notificationGroup.resource.resourceType == 'observation')
                        link = {
                            name: 'observation',
                            params: { observationId: this.notificationGroup.resource._id },
                        }
                    break

                case 'psi':
                    if (this.notificationGroup.resource.resourceType == 'psi')
                        link = {
                            name: 'psi',
                            params: { psiId: this.notificationGroup.resource._id },
                        }

                    break

                case 'contractor':
                    if (this.notificationGroup.resource.resourceType == 'companyDetails')
                        link = {
                            name: 'group-contractors',
                            params: { companyId: this.notificationGroup.resource._id },
                        }

                    break
            }
            return link
        },
        hasOnClickAction() {
            let res = false
            if (
                this.exportFile &&
                new Date().getTime() <= new Date(this.exportFile.expiresAt).getTime()
            ) {
                res = true
            }
            return res
        },
    },
    methods: {
        async markAllAsRead() {
            this.loadingMarkAsRead = true

            let res = await this.notificationGroup.markAllAsRead().catch(() => {
                //
            })

            this.loadingMarkAsRead = false

            if (res) {
                this.$emit('markedAsRead')
            }
        },

        markedAsRead(index) {
            this.notificationGroup.topNotifications.splice(index, 1)
            this.notificationGroup.numNotifications = this.notificationGroup.numNotifications - 1
            if (this.notificationGroup.numNotifications == 0) {
                this.$emit('markedAsRead')
            }
        },

        async loadMoreNotifications() {
            let query = {
                include: ['actingUser'],
                filters: {
                    'filter[read]': this.read,
                    'filter[group]': this.notificationGroup._id,
                    'page[limit]': this.limit,
                    ...(this.read && { 'filter[readAt][le]': this.notificationGroup.leReadAt }),
                    ...(!this.read && { 'filter[time][le]': this.notificationGroup.leTime }),
                },
            }

            let res = await NotificationModel.search(query)
            let arr = [...this.notificationGroup.topNotifications, ...res]
            this.notificationGroup.topNotifications = this.lodash.uniqBy(arr, '_id')
        },

        onClickTitile() {
            if (
                this.exportFile &&
                new Date().getTime() <= new Date(this.exportFile.expiresAt).getTime()
            ) {
                ExportModel.download(this.exportFile.fileId, this.exportFile.filename)
            }
        },
    },
    async mounted() {
        switch (this.notificationGroup.resource.moduleId) {
            case 'observation':
                if (this.notificationGroup.resource.resourceType == 'export') {
                    if (this.notificationGroup.resource._id)
                        this.exportFile = await ExportModel.get(this.notificationGroup.resource._id)
                }
                break
        }
    },
})

export default NotificationGroupComponent
